import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IObservation } from '../../../message-models/observation.interface';
import { ObservationsService } from '../../services/observations.service';
import { ObservationModalService } from '../../services/observation-modal.service';
import { CompanyInfo } from '../../../domain-model/company-info.class';
import { ObservationType, ObservationTypeString } from '../../../domain-model/observation.class';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { consts } from '../../../common/modals/consts';
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { Subscription } from 'rxjs';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { DocumentService } from '../../../documents/services/document.service';
import { CompanyDocumentService } from '../../../company/services/company-documents.service';
import { IDocumentSummaryInfo } from '../../../message-models/document-summary-info.interface';
import { AlertsService } from '../../../alerts/services/alerts.service';


@Component({
  selector: 'app-company-observations',
  templateUrl: './company-observations.component.html',
  styleUrls: ['./company-observations.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompanyObservationsComponent implements OnInit, OnDestroy {

  companyObservations: Array<IObservationSummary> = new Array<IObservationSummary>();
  company: CompanyInfo = new CompanyInfo(null);
  observationsLoading: boolean = true;
  loggedInUser: IUserInfo;
  private companyId: string = consts.emptyGuid;
  subscription: Subscription;
  companyDocumentSummaries: IDocumentSummaryInfo[] = [];

  constructor(public observationsService: ObservationsService,
    private observationModalService: ObservationModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private helpService: HelpModalService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService,
    private confirmProcessService: EcaConfirmProcessService,
    private documentModalService: DocumentModalService,
    private alertsService: AlertsService,
    private companyDocumentService: CompanyDocumentService,) { }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.subscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.setUserAndReloadData(user);
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  private setUserAndReloadData(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if (!this.companyId)
      return;

    this.observationsService.getCompanyObservations(this.companyId).subscribe(result => {
      result.forEach(x => {
        x.observationTypeString = ObservationTypeString[x.observationType];
      })
      this.companyObservations = result;
      this.observationsLoading = false;
      this.populateBreadcrumbs();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }
  createOrEditObservation(observation?: IObservation, isEditing?: boolean, heading?: string) {
    this.observationModalService.createOrEditObservation(observation, heading + this.loggedInUser.companyName, isEditing).subscribe(observationModalRef => {
      observationModalRef.content.saveObservationClicked.subscribe(observationResult => {
        if (observationResult !== null) {
          this.observationsLoading = true
          let editedObservation = observationResult as IObservation;
          editedObservation.observationType = ObservationType.Company;
          let companyObservationId = consts.emptyGuid;
          this.companyObservations.forEach(data => {
            if (data.observationId === editedObservation.id) {
              companyObservationId = data.companyObservationId;
            }
          })
          this.observationsService.createOrUpdateCompanyObservation(editedObservation, this.companyId, companyObservationId).subscribe(result => {
            this.companyObservations = this.observationsService.updateObservationSummaries(this.companyObservations, result);
            this.observationsLoading = false;
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        }
      })
      observationModalRef.content.saveObservationDocumentRequested.subscribe(observationResult => {
        if (observationResult !== null) {
          this.observationsLoading = true
          let editedObservation = observationResult as IObservation;
          editedObservation.observationType = ObservationType.Company;
          let companyObservationId = consts.emptyGuid;
          this.companyObservations.forEach(data => {
            if (data.observationId === editedObservation.id) {
              companyObservationId = data.companyObservationId;
            }
          })
          this.observationsService.createOrUpdateCompanyObservation(editedObservation, this.companyId, companyObservationId).subscribe(result => {
            this.companyObservations = this.observationsService.updateObservationSummaries(this.companyObservations, result);
            this.observationsLoading = false;
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
          this.documentModalService.openDocumentUploaderModal({ documentCreationDate: observationResult.ObservedOn } as IEntityDocumentSummary
            , DocumentEntityType.company, 'Add new Document for Observation')
            .subscribe(documentModalRef => {
              documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
                documentModalRef.dynamicDialogRef.close()
                documentUploadRequest.append('CompanyId', this.companyId);
                this.companyDocumentService.createOrUpdateCompanyDocument(documentUploadRequest).subscribe(companyDocumentSummary => {
                  this.getCompanyDocumentSummaries(this.companyId);
                  this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
                }, () => {
                  this.errorHandlingService.showErrorWarning().subscribe(() => {
                  });
                });
              });
              documentModalRef.content.cancelClicked?.subscribe(() => {
                //this.getTrainingRecordsForOperative();
              });
            });
        }
      })
    });
  }
  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: this.loggedInUser.companyName.toString() + ' - ' + 'Observations', iconName: 'eye' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  openCompanyObservationsHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanyObservationsHelp);
  }

  getCompanyDocumentSummaries(companyId: string, includeExpired: boolean = false) {
    this.companyDocumentService.getAllDocumentSummariesByEntityType(companyId, DocumentEntityType.company, includeExpired).subscribe(companyDocuments => {
      this.companyDocumentSummaries = companyDocuments;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }
}
